import { useMediaQuery } from '@mui/material';
import { useRef, useState } from 'react';

export const useCatalogBannerCarousel = (slideCount: number) => {
  const trackRef = useRef<HTMLDivElement>(null);
  const [scrolledIndex, setScrolledIndex] = useState(0);
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  const activeIndex = Math.min(scrolledIndex, slideCount - 1);

  const scrollToIndex = (index: number) => {
    const track = trackRef.current;

    if (!track) {
      return;
    }

    track.scrollTo({
      left: ((index + slideCount) % slideCount) * track.clientWidth,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  };

  const handleScroll = () => {
    const track = trackRef.current;

    if (!track || track.clientWidth === 0) {
      return;
    }

    setScrolledIndex(Math.round(track.scrollLeft / track.clientWidth));
  };

  return {
    trackRef,
    activeIndex,
    scrollToIndex,
    goToPrevious: () => scrollToIndex(activeIndex - 1),
    goToNext: () => scrollToIndex(activeIndex + 1),
    handleScroll,
  };
};
